import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faTrash } from "@fortawesome/free-solid-svg-icons";
import * as notify from "../../../../../shared/notify";

import AnalysisItem from "./analysis-item";

import { Input } from "../../../../form-inputs/inputs";
import { addNutrient } from "../lib/constants";

const AnalysisItemList = (props) => {
    const columnCount = props.data.columnHeaders.length;
    const addNew = () => {
        const newItems = [...props.data.items];
        const template = addNutrient(columnCount);
        const stamp = Math.round(new Date().getTime() / 1000);
        newItems.push({ ...template, key: `analysis_${stamp}` });
        props.updateFieldDeep("analysis", "items", newItems);
    };
    const removeItem = (key) => {
        const newItems = props.data.items.filter((d) => d.key !== key);
        props.updateFieldDeep("analysis", "items", newItems);
    };
    const updateItems = (value, index) => {
        const newItems = props.data.items.map((item, i) => {
            if (i === index) {
                return value;
            }

            return item;
        });

        props.updateFieldDeep("analysis", "items", newItems);
    };
    const updateHeader = (index, value) => {
        const newData = { ...props.data };
        newData.columnHeaders[index] = value;
        props.updateFieldDeep("analysis", "columnHeaders", newData.columnHeaders);
    };
    const addAnalysisColumn = () => {
        if (columnCount === 3) {
            notify.error("Only 3 Measurement Columns are allowed.");

            return;
        }

        props.addColumn();
    };
    const widthHeader = { gridTemplateColumns: `300px 150px repeat(${columnCount}, 1fr) 30px` };
    const widthItems = { gridTemplateColumns: `100px 225px 125px repeat(${columnCount}, 1fr) 30px` };
    const headers = props.data.columnHeaders.map((header, index) => {
        return (
            <div key={`column_${index}`} className="button-group">
                <Input
                    name={`header_${index}`}
                    value={header}
                    placeholder="Measurement Header"
                    updateOnChange={(name, value) => {
                        updateHeader(index, value);
                    }}
                />
                {columnCount > 1 && (
                    <button
                        className="button -small"
                        onClick={() => {
                            props.removeColumn(index);
                        }}
                    >
                        <FontAwesomeIcon icon={faTrash} />
                    </button>
                )}
            </div>
        );
    });

    const measurementHeaders = props.data.columnHeaders.map((header, index) => {
        return <h4 key={`h4_${index}`}>Measurement</h4>;
    });
    const items = props.data.items.map((item, index) => {
        return (
            <AnalysisItem
                key={item.key}
                data={item}
                style={widthItems}
                updateField={(value) => {
                    updateItems(value, index);
                }}
                removeItem={removeItem}
            />
        );
    });
    const disableClass = columnCount === 3 ? " -disabled" : "";

    return (
        <div className="analysis-item-list">
            <div className="analysis-title" style={widthHeader}>
                <h4>Guaranteed Analysis</h4>
                <button className={`button -primary -small -right${disableClass}`} onClick={addAnalysisColumn}>
                    Add Column
                </button>
                {headers}
            </div>
            <div className="analysis-item" style={widthItems}>
                <h4>Note Mark</h4>
                <h4>Nutrient</h4>
                <h4>Min/Max</h4>
                {measurementHeaders}
            </div>

            {items}

            <button className="button -primary -small" onClick={addNew}>
                <FontAwesomeIcon icon={faPlus} /> Add
            </button>
        </div>
    );
};

export default AnalysisItemList;
